import { getPercentageDiff, randomInt } from '@workalizer/shared/utils';
var randomPeriod = function () { return ({
    views: randomInt(100, 180),
    edits: randomInt(50, 90),
    commentsPosted: randomInt(40, 65),
    suggestionsPosted: randomInt(35, 60),
    downloads: randomInt(18, 35),
    prints: randomInt(10, 25),
    sharedInternally: randomInt(6, 14),
    sharedExternally: randomInt(2, 8),
    collaborators: randomInt(4, 10)
}); };
var buildCountMetric = function (count, previousCount) { return ({
    count: count,
    previous: getPercentageDiff(previousCount, count)
}); };
var buildResponse = function (current, previous) { return ({
    viewsEdits: {
        left: buildCountMetric(current.views, previous.views),
        right: buildCountMetric(current.edits, previous.edits)
    },
    commentsSuggestions: {
        left: buildCountMetric(current.commentsPosted, previous.commentsPosted),
        right: buildCountMetric(current.suggestionsPosted, previous.suggestionsPosted)
    },
    downloadsPrints: {
        left: buildCountMetric(current.downloads, previous.downloads),
        right: buildCountMetric(current.prints, previous.prints)
    },
    sharing: {
        internal: buildCountMetric(current.sharedInternally, previous.sharedInternally),
        external: buildCountMetric(current.sharedExternally, previous.sharedExternally)
    },
    collaborators: buildCountMetric(current.collaborators, previous.collaborators)
}); };
export var documentFileSummary = function (_input) {
    return buildResponse(randomPeriod(), randomPeriod());
};
